module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    staticClass: "text-center p-50"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-5x fa-spinner"
  })]) : _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }), _vm._v(" "), _c('div', {
    staticClass: "block-content p-0"
  }, [_c('table', {
    staticClass: "table table-borderless table-striped table-hover"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.paymentTransactions), function(paymentTransaction) {
    return _c('tr', {
      key: paymentTransaction
    }, [_c('td', [_vm._v(" " + _vm._s(paymentTransaction.reference) + " ")]), _vm._v(" "), _c('td', [_vm._v(" € " + _vm._s(paymentTransaction.amount) + " ")]), _vm._v(" "), _c('td', [_vm._v(" € " + _vm._s(paymentTransaction.openAmount) + " ")]), _vm._v(" "), _c('td', [(paymentTransaction.files.length == 0) ? _c('span', [_vm._v("Geen bestanden geüpload")]) : _c('div', {
      staticStyle: {
        "display": "flex",
        "flex-direction": "column"
      }
    }, _vm._l((paymentTransaction.files), function(file) {
      return _c('span', {
        key: file
      }, [_vm._v(" " + _vm._s(file) + " ")])
    }), 0)]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "row"
    }, [_c('input', {
      staticClass: "form-control",
      staticStyle: {
        "width": "350px"
      },
      attrs: {
        "type": "file"
      },
      on: {
        "change": _vm.onFileChange
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-success btn-noborder",
      attrs: {
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.uploadFile(paymentTransaction)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check"
    })])])])])
  }), 0)])])]), _vm._v(" "), (!_vm.loading) ? _c('button', {
    staticClass: "btn btn-danger btn-noborder",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.deleteFiles()
      }
    }
  }, [_vm._v("\n    Verwijder alle bestanden\n  ")]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Referentie nummer")]), _vm._v(" "), _c('th', [_vm._v("Totaal bedrag")]), _vm._v(" "), _c('th', [_vm._v("Openstaand bedrag")]), _vm._v(" "), _c('th', [_vm._v("Geüploade bestanden")]), _vm._v(" "), _c('th', [_vm._v("Upload")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f937ca1a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/settings/AmazonXmlUploadTab.vue
// module id = 764
// module chunks = 1